/**
 * useInstallPromptEnhancer
 *
 * Watches the DOM for the third-party add-to-homescreen modal (`.adhs-container`)
 * and injects a localized info message at the bottom when it appears.
 *
 * This is a Neobet-only enhancement. Other skins leave the modal unmodified.
 * Uses a MutationObserver so the injection survives modal re-renders.
 */
import { useEffect } from 'react';
import { useSkin } from '../contexts/SkinContext';
import { SKIN } from '../types/enums';
import useLocalization from './useLocalization';

export const useInstallPromptEnhancer = () => {
  const { skin } = useSkin();
  const { t } = useLocalization();

  useEffect(() => {
    if (skin !== SKIN.NEOBET) return;

    const observer = new MutationObserver(() => {
      const container = document.querySelector('.adhs-container');
      // Guard: container not found or info already injected.
      if (!container || container.querySelector('.adhs-install-later-info')) return;

      const infoEl = document.createElement('div');
      infoEl.className = 'adhs-install-later-info';
      infoEl.textContent = t(
        'installLaterInfo',
        'Install later? You can find install app option in left sidebar menu and footer section.'
      );

      const modal = container.querySelector('.adhs-modal');
      if (modal) {
        modal.appendChild(infoEl);
      } else {
        container.appendChild(infoEl);
      }
    });

    observer.observe(document.body, { childList: true });
    return () => observer.disconnect();
  }, [t, skin]);
};
